import * as React from 'react'
import {Text} from 'wix-ui-tpa/Text'
import {classes} from './item.st.css'
import {LegendItemProps} from '.'

export const LegendItem = ({color, label}: LegendItemProps) => (
  <li className={classes.legendItem}>
    <div
      className={classes.color}
      style={{backgroundColor: color, border: color === '#fff' ? '1px solid black' : undefined}}
    />
    <Text className={classes.text}>{label}</Text>
  </li>
)
